import clsx from 'clsx'

const lineColorClass = (color: 'secondary' | 'tertiary') => {
  switch (color) {
    case 'secondary':
      return 'border-secondary'
    case 'tertiary':
      return 'border-tertiary'
  }
}

interface Props {
  color?: 'secondary' | 'tertiary'
  dashed?: boolean
}

const Line = ({ color = 'secondary', dashed = false }: Props) => {
  return (
    <>
      <hr
        className={clsx(
          `m-0 w-full border-t p-0`,
          lineColorClass(color),
          dashed && 'border-dashed'
        )}
      />
    </>
  )
}

export default Line
